export default {
  title: 'Verify it’s you',
  subtitle: 'Enter the 4-digit verification code sent to the phone number ending in ',
  resendCode: 'Resend code in ',
};
